<div class="h-full flex flex-col overflow-visible">
    <div
        class="shrink-0 flex flex-row gap-x-4 items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 overflow-visible">

        @if (briefId) {
        <button (click)="backToBrief()" type="button" class="btn-fab-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m12 19-7-7 7-7" />
                <path d="M19 12H5" />
            </svg>
        </button>
        }

        <div class="flex-1 flex flex-row items-center justify-start gap-x-2">
            <div class="grid grid-cols-1 w-1/5">
                <input id="creator-keyword-search" type="search" name="creator-search" placeholder="Search Creators"
                    class="col-start-1 row-start-1 block w-full py-1.5 pr-3 pl-10 input-primary-icon"
                    [value]="magicSearchService.searchQuery() ?? ''"
                    (input)="onKeywordSearchInput($any($event.target).value)"
                    aria-label="Search by name or creator ID" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-secondary sm:size-4">
                    <path d="m21 21-4.34-4.34" />
                    <circle cx="11" cy="11" r="8" />
                </svg>
            </div>

            <cv4f-find-creators-filters mode="trigger" />

            <button routerLink="/creators-my-groups" type="button"
                class="inline-flex items-center gap-1.5 rounded-md border border-zinc-200 dark:border-white/10 bg-white dark:bg-transparent px-3 py-2 text-xs font-medium text-secondary hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary">
                <p class="m-0">My Groups</p>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-4" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                </svg>
            </button>

            <cv4f-find-creators-filters mode="chips" />
        </div>

        <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">

            @let sortToolbarOptions = magicSearchService.fancyActiveFilters.sortOptions ??
            magicSearchService.activeFilters.sortOptions ?? [];
            @if (sortToolbarOptions.length) {
            <el-select id="creators-v4-sort-select" name="sortSelected" [value]="toolbarSortSelectValue()"
                class="block w-52 min-w-[12rem]">
                <button type="button"
                    class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:focus-visible:outline-primary">
                    <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                        <div
                            class="shrink-0 p-1 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5">
                                <path d="m3 16 4 4 4-4" />
                                <path d="M7 20V4" />
                                <path d="M11 4h10" />
                                <path d="M11 8h7" />
                                <path d="M11 12h4" />
                            </svg>
                        </div>
                        <span class="block truncate">{{ toolbarSortDisplayName() }}</span>
                    </el-selectedcontent>
                    <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                        class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400">
                        <path
                            d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                            clip-rule="evenodd" fill-rule="evenodd" />
                    </svg>
                </button>

                <el-options anchor="bottom start" popover
                    class="max-h-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10 scrollbar-transparent">
                    @for (sortOption of sortToolbarOptions; track sortOption.id) {
                    <el-option [value]="'' + sortOption.id" (click)="onToolbarSortOptionSelected(sortOption)"
                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                        <div class="flex flex-col items-stretch text-left">
                            <span class="block truncate font-normal"
                                [class.font-semibold]="isToolbarSortOptionSelected(sortOption)">{{ sortOption.name
                                }}</span>
                            @if (sortOption.description) {
                            <span
                                class="mt-0.5 block text-xs text-gray-500 group-focus/option:text-white dark:text-gray-400 dark:group-focus/option:text-white">{{
                                sortOption.description }}</span>
                            }
                        </div>
                        @if (isToolbarSortOptionSelected(sortOption)) {
                        <span
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-focus/option:text-white">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </span>
                        }
                    </el-option>
                    }
                </el-options>
            </el-select>
            }


            <!-- Collaborate Btn -->
            <div #collaboratorsFab class="relative overflow-visible">
                <button type="button" (click)="collaboratorsService.showCollaborators.set(true)"
                    class="btn-shout-fab-primary"
                    [class.collaborators-fab--attention]="fabAttention()"
                    aria-label="Selected collaborators">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6" aria-hidden="true">
                        <path d="M16 5H3" />
                        <path d="M11 12H3" />
                        <path d="M16 19H3" />
                        <path d="M18 9v6" />
                        <path d="M21 12h-6" />
                    </svg>
                </button>
                @if (collaboratorsService.selectedCreators().length > 0) {
                <span
                    class="z-10 absolute -top-3 -right-3 inline-flex items-center rounded-full bg-primary/10 dark:bg-primary/15 px-2 py-0.5 text-sm font-medium text-accent ring-1 ring-inset ring-primary/15 dark:ring-primary/30"
                    [class.collaborators-badge--attention]="badgeAttention()">
                    {{ collaboratorsService.selectedCreators().length }}</span>
                }
                <p class="sr-only" aria-live="polite" aria-atomic="true">
                    {{ collaboratorsService.selectedCreators().length }} creator{{
                    collaboratorsService.selectedCreators().length === 1 ? '' : 's' }} selected
                </p>
            </div>
            <!-- Collaborate Btn  END-->

            <!-- Screening Button -->
            <!-- <div class="relative overflow-visible">
                <button type="button" (click)="socialScreeningService.showToBeScreeneed.set(true)"
                    class="btn-fab-custom bg-teal-500 text-white hover:bg-teal-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                        <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                        <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                        <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                        <path d="M8 7v10" />
                        <path d="M12 7v10" />
                        <path d="M17 7v10" />
                    </svg>
                </button>
                @if (socialScreeningService.selectedCreators().length > 0) {
                <span
                    class="z-10 absolute -top-3 -right-3 inline-flex items-center rounded-full bg-teal-50 px-2 py-0.5 text-sm font-medium text-teal-700 ring-1 ring-inset ring-teal-700/10">
                    {{ socialScreeningService.selectedCreators().length }}</span>
                }
            </div> -->
            <!-- Screening Button -->
        </div>

    </div>

    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
        @if (magicSearchService.blueSearchResults() && magicSearchService.blueSearchResults()!.length > 0) {
        <div #resultsScroll class="h-full w-full flex flex-col gap-4 overflow-y-auto scrollbar-transparent pt-4"
            (scroll)="onResultsScroll($event)">
            @for (creator of magicSearchService.blueSearchResults()!; track creator.blazeFirebaseUid) {
            <cv4f-blue-gold-search-item [creator]="creator"></cv4f-blue-gold-search-item>
            }
        </div>
        } @else if (magicSearchService.blueSearchResults() && magicSearchService.blueSearchResults()!.length == 0) {


        <div class="h-full w-full flex flex-col items-center justify-center py-12 px-4">
            <div class="max-w-lg text-center">
                <div
                    class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/15">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-8 text-accent">
                        <path d="M2 21a8 8 0 0 1 11.873-7" />
                        <circle cx="10" cy="8" r="5" />
                        <path d="m17 17 5 5" />
                        <path d="m22 17-5 5" />
                    </svg>
                </div>
                <h3 class="mt-6 text-lg font-semibold text-primary">No creators found</h3>
                @if (hasActiveFilters()) {
                <p class="mt-3 text-sm leading-6 text-secondary">
                    Try updating or clearing some of your filters to see more results.
                </p>
                } @else {
                <p class="mt-3 text-sm leading-6 text-secondary">
                    Try updating or clearing some of your filters to see more results.
                </p>
                }

            </div>
        </div>
        } @else {
        <div class="h-full w-full flex flex-col items-center justify-center">
            <atom-loading-inline [loaderSize]="16" [hideMessage]="true"></atom-loading-inline>
        </div>
        }
    </div>
</div>

@if (collaboratorsService.showCollaborators()) {
<cc-collaborators></cc-collaborators>
}
@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"></cc-creator-profile>
}
@if (socialScreeningService.showToBeScreeneed()) {
<sb-creators-for-list></sb-creators-for-list>
}


@if (magicSearchService.previewVideo()) {
<atom-video-carousel class="z-[999]" [video]="magicSearchService.previewVideo()!"
    [playlist]="magicSearchService.previewVideoPlaylist() ?? []"
    (videoChange)="magicSearchService.previewVideo.set($event)"
    (closePreviewOut)="magicSearchService.clearPreviewVideo()"></atom-video-carousel>
}